const showTitle = (event: any, title: string) => {
  if (event.currentTarget.scrollWidth > event.currentTarget.offsetWidth) {
    event.currentTarget.title = title
  }
}

export const useShowTitle = () => ({
  showTitle,
})
